@use '@/styles/_colors.scss' as *;

:export {
  // Program Status chart colors
  chartCompliant: $color-chart-compliant;
  chartDueSoonScheduled: $color-chart-due-soon-scheduled;
  chartDueSoonNotScheduled: $color-chart-due-soon-not-scheduled;
  chartOverdueScheduled: $color-chart-overdue-scheduled;
  chartOverdueNotScheduled: $color-chart-overdue-not-scheduled;
  chartNoRecord: $color-chart-no-record;

  accentProduction: $color-accent-production;
  accentSandbox: $color-accent-sandbox;

  mainPrimary: $color-main-primary;
  mainAccent: $color-main-accent;
  mainSecondary: $color-main-secondary;
  mainTertiary: $color-main-tertiary;
  mainQuaternary: $color-main-quaternary;

  accentPrimary: $color-accent-primary;
  accentSuccess: $color-accent-success;
  accentError: $color-accent-error;
  accentWarning: $color-accent-warning;

  contentPrimary: $color-content-primary;
  contentSecondary: $color-content-secondary;
  contentTertiary: $color-content-tertiary;
  contentQuaternary: $color-content-quaternary;

  textPrimary: $color-text-primary;
  textAlternate: $color-text-alternate;
  backgroundDefault: $color-background-default;
  alternateBackground: $color-alternate-background;
  backgroundAccent: $color-background-accent;

  dark100: $color-dark-100;
  dark86: $color-dark-86;
  dark76: $color-dark-76;
  dark56: $color-dark-56;
  dark36: $color-dark-36;
  dark26: $color-dark-26;
  dark16: $color-dark-16;
  dark8: $color-dark-8;
  dark4: $color-dark-4;
  dark2: $color-dark-2;

  light100: $color-light-100;
  light86: $color-light-86;
  light76: $color-light-76;
  light36: $color-light-36;
  light26: $color-light-26;
  light16: $color-light-16;
  light8: $color-light-8;
  light2: $color-light-2;

  backgroundGradient: $background-gradient;
}
